import { ReactNode } from "react";

import EmptyState from "@buildpy/ui/empty-state";
import SectionCard from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";

interface Props {
  // md 이상에서 보이는 표(테두리 감싸개까지 포함).
  table: ReactNode;
  // md 아래에서 보이는 카드 — ListCard 를 key 와 함께 넘긴다.
  cards: ReactNode[];
  // 카드 목록 이름(스크린 리더).
  label: string;
  // 카드가 없을 때 문구 — 없으면 아무것도 그리지 않는다(표 쪽이 빈 행을 그린다).
  empty?: ReactNode;
  testId?: string;
}

// 좁은 폭(md 아래)은 카드 목록, 그 이상은 표 — 폰에서 표가 옆으로 밀려 버튼·상태가 잘리던 자리(C3).
const ResponsiveList = ({ table, cards, label, empty, testId }: Props) => (
  <>
    <div className="hidden md:block">{table}</div>
    {cards.length > 0 ? (
      <ul aria-label={label} className="flex min-w-0 flex-col gap-y-2 md:hidden" data-testid={testId}>
        {cards}
      </ul>
    ) : (
      empty && <EmptyState className="md:hidden">{empty}</EmptyState>
    )}
  </>
);

interface CardProps {
  children: ReactNode;
  className?: string;
  testId?: string;
}

// 카드 한 장 — relative 라 안의 링크가 after:absolute 로 카드 전체를 덮을 수 있다(버튼은 relative z-10 으로 위에).
export const ListCard = ({ children, className, testId }: CardProps) => (
  <SectionCard
    as="li"
    className={cn("relative flex min-w-0 flex-col gap-y-1.5 text-sm", className)}
    data-testid={testId}
    padding="sm">
    {children}
  </SectionCard>
);

export default ResponsiveList;
